
import config from '@/config'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import { Toast } from 'vant'
import { getCheckType } from '@/api/yuangongquan'
import { getCommentReport, addReport } from '@/api/shuping'
export default {
components: { Checker, CheckerItem },
data () {
return {
baseUrl: config.baseUrl,
checkList: [],
checktype: [],
momentsid: this.$route.params.commentid,
obj: {},
baseObj: {}
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.getBase()
this.getCheckList()
},
methods: {

getCheckList () {
getCheckType({
addTreeNode: 1
}).then(res => {
this.obj = res.obj
})
},
getBase () {
getCommentReport({
commentid: this.momentsid
}).then(res => {
this.baseObj = res.obj
})
},
submit () {
let checktype = this.checktype.join(';')
addReport({
type: checktype,
accountid: this.accountid,
commentid: this.momentsid
}).then(res => {
Toast.success('提交成功')
setTimeout(() => {
this.$router.push({ name: 'commentDetail', params: { bookid: this.baseObj.bookid } })
}, 1200)
})
}
}
}
